import { Box, Grid, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import ColorInput from './ColorInput';
import ReadOnlyValue from './ReadOnlyValue';

export const COLOR_FIELDS = [
  { source: 'color', label: 'Cor principal' },
  // Acento do template: fios e a linha alternada da manchete. Fica logo depois
  // da principal porque as duas andam em par na arte gerada.
  { source: 'secondaryColor', label: 'Cor secundária' },
  { source: 'headerLabelColor', label: 'Cor da fonte na home' },
  { source: 'signUpButtonColor', label: 'Cor do botão de cadastro' },
  { source: 'signInButtonColor', label: 'Cor do botão de login' },
] as const;

interface Props {
  readOnly?: boolean;
  /** Cores extraídas das fotos do posto, no card ao lado. */
  palette: string[];
  record: Record<string, any>;
}

const ColorsCard = ({ readOnly, palette, record }: Props) => {
  const { setValue } = useFormContext();
  const [target, setTarget] = useState<string>('color');

  if (readOnly) {
    return (
      <Grid container spacing={2}>
        {COLOR_FIELDS.map(({ source, label }) => (
          <ReadOnlyValue key={source} label={label} value={record[source]} size={6} swatch />
        ))}
      </Grid>
    );
  }

  const targetLabel = COLOR_FIELDS.find(field => field.source === target)?.label;

  return (
    <>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        {COLOR_FIELDS.map(({ source, label }) => (
          <ColorInput
            key={source}
            source={source}
            label={label}
            onFocus={() => setTarget(source)}
          />
        ))}
      </Box>

      {!!palette.length && (
        <Box sx={{ mt: 1.5 }}>
          <Typography variant="caption" color="text.secondary">
            Cores encontradas nas fotos — clique para aplicar em <strong>{targetLabel}</strong>:
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
            {palette.map(hex => (
              <Tooltip key={hex} title={hex}>
                <Box
                  onClick={() => setValue(target, hex, { shouldDirty: true })}
                  sx={{
                    width: 32, height: 32, borderRadius: 1, backgroundColor: hex,
                    border: '1px solid', borderColor: 'divider', cursor: 'pointer',
                  }}
                />
              </Tooltip>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export default ColorsCard;
